import { getTranslation } from '../language';

export const ERRORS = (countryCode?: string) => ({
    CCNUMBER_ERROR: getTranslation('CCNUMBER_ERROR', countryCode),
    EXP_ERROR: getTranslation('EXP_ERROR', countryCode),
    CVV_ERROR: getTranslation('CVV_ERROR', countryCode),
    HOLDER_NAME_ERROR: getTranslation('HOLDER_NAME_ERROR', countryCode),
    COUNTRY_ERROR: {
        message: 'Wrong format in country field. It must be a 2 character string. For example: BR.'
    },
    INSTALLMENTS_ERROR: {
        message: 'There was an error getting the installments.'
    },
    GET_BIN_ERROR: {
        message: 'There was an error getting the bin information.'
    },
    GET_VIRTUAL_CARD_ERROR: {
        message: 'There was an error getting the virtual card information.'
    },
    TOKENIZE_ERROR: {
        message: 'There was an error in the tokenization.'
    },
    API_KEY_ERROR: {
        message: 'Your API key is invalid.'
    },
    BIN_ERROR: {
        message: 'There was an error getting the bin information.'
    }
});
